// Small shared bits for the WhatsApp Store pages
import React from 'react';

export const naira = n => `₦${Number(n || 0).toLocaleString('en-NG', { maximumFractionDigits: 2 })}`;
export const ago = secs => {
  if (secs == null) return '';
  if (secs < 60) return 'just now';
  if (secs < 3600) return `${Math.floor(secs / 60)} min ago`;
  if (secs < 86400) return `${Math.round(secs / 3600)} h ago`;
  return `${Math.round(secs / 86400)} d ago`;
};
export function Switch({ on, onChange, label, disabled }) {
  return <button type="button" role="switch" aria-checked={on} aria-label={label} disabled={disabled}
    className={`stp-switch ${on ? 'is-on' : ''}`} onClick={() => onChange(!on)}><span /></button>;
}

